var TextEditor = (function($, _) {
    String.prototype.hexEncode = function(){
        var hex, i;

        var result = "";
        for (i=0; i<this.length; i++) {
            hex = this.charCodeAt(i).toString(16);
            result += '\\u'+ ("000"+hex).slice(-4);
        }

        return result
    }


    var validTags = ['p','br','a','ol','ul','li','strong','em','sup','sub','abbr','acronym','blockquote','div','span','del','small'];
    var blockLevelTags = ['p','ol','ul','li','blockquote','div'];
    var replaceTags = {
        'b' : 'strong',
        'i' : 'em'
    };
    var regs = [
        {subject: new RegExp("\\*","g"), replace: "&#42;"},
        {subject: /\s((&nbsp;)+)/g, replace: "$1"},
        {subject: /((&nbsp;)+)\s+/g, replace: "$1"},
        {subject: /^(&nbsp;|\s)+/, replace: ""},
        {subject: /(&nbsp;|\s)+$/, replace: ""},
        {subject: / '/, replace: "'"},
        {subject: /\udbc0./g, replace: ""},
        {subject: /&(?!(#|amp;|lt;|gt;|quot;|nbsp;))/g, replace: "&#38;$1"}
    ];

    function removeNode(el) {
        var $el = $(el);
        $el.replaceWith($el.html());
    }

    function findClosestBlock(el) {
        if (!el.tagName) {
            return (el!==el.parentNode) ? findClosestBlock(el.parentNode) : null;
        }

        if (_.contains(blockLevelTags, el.tagName.toLowerCase()))
            return el;

        return (el!==el.parentNode) ? findClosestBlock(el.parentNode) : null;
    }


    // http://heima.olivant.fo/~styrheim/tools/entify.html
    function dec2hex(i) {
        var palette = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F'],
            d1, c1, d2, c2, d3, c3, c4;
        d1 = i%16; i = (i-d1)/16;
        c1 = palette[d1];
        d2 = i%16; i = (i-d2)/16;
        c2 = palette[d2];
        d3 = i%16; i = (i-d3)/16;
        c3 = palette[d3];
        c4 = palette[i];
        return (c4 + c3 + c2 + c1).toString();
    }
    function shallEntify(i) {
        return (i>64000);
    }

    function entify(s) {
        var r="", i, l;
        for (i=0, l=s.length; i<l; i++) {
            if (shallEntify(s.charCodeAt(i)))
                r+= '&#x'+dec2hex(s.charCodeAt(i))+';';
            else
                r+= s.charAt(i);
        }
        return r;
    }


    var getComputedDisplay = (typeof window.getComputedStyle != "undefined") ?
        function(el) {
            return window.getComputedStyle(el, null).display;
        } :
        function(el) {
            return el.currentStyle.display;
        };

    function replaceWithOwnChildren(el) {
        var parent = el.parentNode;
        while (el.hasChildNodes()) {
            parent.insertBefore(el.firstChild, el);
        }
        parent.removeChild(el);
    }

    function cleanupHTML (el, opts) {
        var $el = $(el), html, re, reEmpty=/^\s*$/;

        el = $el.get(0);
        opts = opts || {};

        // namespaces?
        el.innerHTML = el.innerHTML.replace(/<(\/?)([^:>\s]*:)?([^>]+)>/g, "<$1$3>");

        // conditional html
        el.innerHTML = el.innerHTML.replace(/<!--.*?>/g, '');
        el.innerHTML = el.innerHTML.replace(/<!--\[endif\]---->/g, '');
        $el.find('xml').remove();
        $el.find('style').remove();


        if (opts.mode!=='paragraph') {
            _.each(blockLevelTags, function(tag) {
                $el.find(tag).each(function() {
                    removeNode(this);
                });
            });
        }

        html = $el.html();
        re=/\s+<\/a>/ig;
        $el.html(html.replace(re, '</a> '));


        _.each(replaceTags, function(to, from) {
            $el.find(from).replaceWith(function() {
                return $('<'+to+' />', {html: $(this).html()});
            });
        });

        var bytag = {
            a: function(el) {
                return !el.getAttribute('href');
            },
            div: function(el) {
                return ((!el.className)||(el.className.length<3));
            },
            span: function(el) {
                return !el.className && !el.getAttribute('lang');
            }
        };
        _.each(bytag, function(f, tag) {
            $el.find(tag).each(function() {
                if (f(this)) {
                    removeNode(this);
                }
            });
        });

        var killed = [];
        $el.find('br').each(function() {
            var ptag = this.parentNode;
            if ((!ptag) || (!ptag.tagName)) return;
            if (!_.contains(blockLevelTags, ptag.tagName.toLowerCase())) return;

            if (!this.nextSibling)
                killed.push(this);
        });
        _.each(killed, function(n) {
            $(n).remove();
        });

        $el.find('*:not(.rangySelectionBoundary)').removeAttr('style').each(function() {
            var $el = $(this),
                tag = this.tagName,
                attrs;

            if (!tag) return;
            tag = tag.toLowerCase();

            if (!_.contains(validTags, tag)) {
                $el.attr('tokill', true);
                return;
            }

            if ((tag!=='br')&&(reEmpty.test($el.text()))) {
                $el.remove();
                return;
            }

            if (this.className.indexOf("nps")!==0) {
                this.removeAttribute('class');
            }
            if (tag==='a') return;


            attrs = _.filter(this.attributes, function(attr) {
                return (attr.specified) && (!_.contains(['href', 'title', 'cite', 'class', 'lang'], attr.name)) ;
            });

            _.each(attrs, function(attr) {
                $el.removeAttr(attr.name);
            });
        });


        // remplacement des tags acronym
        $('acronym').replaceWith(function(){
            var $was = $(this),
                $tag = $("<abbr />", {html: $was.html()})
            ;
            if ($was.attr('title')) {
                $tag.attr('title', $was.attr('title'));
            }
            return $tag;
        });


        while ($el.find('[tokill]').length) {
            $el.find('[tokill]').first().replaceWith(function() { return $(this).contents(); });
        }

        $el.find('span').each(function() {
            var $span = $(this),
                lst = _.flatten([blockLevelTags, 'span']);

            _.each(lst, function(tag) {
                $span.find(tag).each(function() {
                    removeNode(this);
                });
            });
        });
        $el.find('blockquote').each(function() {
            var $blk = $(this);
            if ($blk.parent('p').length)
                $blk.unwrap();
        });

        if (opts.mode!=='paragraph')
            return;


        var mkins = [], mempty=true, dummy = $('<p></p>');
        $el.append(dummy);
        $el.contents().each(function() {
            var txt = (this.nodeType === 3),
                empty = txt && reEmpty.test(this.nodeValue),
                inline = !txt && !_.contains(blockLevelTags, this.tagName.toLowerCase());

            if (txt||inline) {
                mempty = mempty && empty;
                mkins.push(this);
            } else {
                if (!mempty) {
                    $(_.clone(mkins)).wrapAll('<p>');
                }
                mkins = [];
                mempty=true;
            }
        });
        dummy.remove();
    }



    function editor(el, opts) {
        var $el = $(el), self = this;
        el = $el.get(0);
        this.$el = $el;
        this.el = el;

        opts = this.opts = _.defaults({}, opts, {
            mode: "text",
            newlines: false,
            disablePurifyChars:false
        });

        var maxlength = +this.opts.maxlength;

        this.cleanup();

        var html = this.html();
        this.original = html;
        this.$el.html(html);

        var allowNewlines = !!this.opts.newlines;


        $el.on('keydown', function(e) {
            var selection, range;
            switch (e.keyCode) {
                case 32:
                    if (e.ctrlKey && e.shiftKey) {
                        var nonbreakspace = "\u00a0";// non breakable space
                        if (window.getSelection) {
                            selection = window.getSelection();
                            if (selection.getRangeAt && selection.rangeCount) {
                                range = selection.getRangeAt(0);
                                range.deleteContents();
                                var textNode = document.createTextNode(nonbreakspace);
                                range.insertNode(textNode);

                                // Move caret to the end of the newly inserted text node
                                range.setStart(textNode, textNode.length);
                                range.setEnd(textNode, textNode.length);
                                selection.removeAllRanges();
                                selection.addRange(range);
                            }
                        } else if (document.selection && document.selection.createRange) {
                            range = document.selection.createRange();
                            range.pasteHTML(nonbreakspace);
                        }
                        return false;
                    }
                    break;
                case 13:
                    if (opts.mode!=="paragraph") {
                        if (allowNewlines) {
                            var br = document.createElement('br');
                            selection = window.rangy.getSelection();
                            range = selection.getRangeAt(0);

                            range.insertNode(br);

                            range = window.rangy.createRange();
                            range.setStartAfter(br);
                            range.setEndAfter(br);
                            selection.removeAllRanges();
                            selection.addRange(range);
                        } else {
                            self.commit();
                        }
                        return false;
                    }
                    break;
            }
        });

        function maxlengthed() {
            var $maxlength, lgt;
            if (!maxlength) return;

            $maxlength = $el.parent().find('[data-role="maxlength"]');
            lgt = $el.text().length;

            $maxlength.text(lgt + ' / ' + maxlength);
            $maxlength.toggleClass('maxlength-over', lgt > maxlength);
        }

        $el.on('keyup paste', maxlengthed);
        maxlengthed()
    }

    editor.prototype.destroy = function () {
        this.release();
        this.$el.off('keydown');
        return this;
    };

    editor.prototype.editable = function () {
        this.$el.attr('contenteditable', true);
        return this;
    };


    function getMouseEventCaretRange(evt) {
        var range, x = evt.clientX, y = evt.clientY;
        if ((!evt.clientX) && (!evt.clientY))
            return null;

        // Try the simple IE way first
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            try {
                range.moveToPoint(x, y);
            } catch(e) {
                range = null;
            }
        }

        else if (typeof document.createRange != "undefined") {
            // Try Mozilla's rangeOffset and rangeParent properties,
            // which are exactly what we want
            if ((typeof evt.rangeParent != "undefined") && (evt.rangeParent)) {
                range = document.createRange();
                range.setStart(evt.rangeParent, evt.rangeOffset);
                range.collapse(true);
            }

            // Try the standards-based way next
            else if (document.caretPositionFromPoint) {
                var pos = document.caretPositionFromPoint(x, y);
                range = document.createRange();
                range.setStart(pos.offsetNode, pos.offset);
                range.collapse(true);
            }

            // Next, the WebKit way
            else if (document.caretRangeFromPoint) {
                range = document.caretRangeFromPoint(x, y);
            }
        }

        return range;
    }



    editor.prototype.activate = function (e) {
        if (!this.isActive()) {
            this.editable();
            this.$el.focus();
        }

        if ((this.opts.mode==="paragraph") && (this.$el.html()==='')) {
            _.defer(function() {
                document.execCommand('formatBlock', false, 'p');
            });
        } else {
            // http://stackoverflow.com/questions/12920225/text-selection-in-divcontenteditable-when-double-click

            if (e && e.originalEvent) {
                var range = getMouseEventCaretRange(e.originalEvent);

                if (range) {
                    _.defer(function() {
                        if (typeof range.select != "undefined") {
                            range.select();
                        } else if (typeof window.getSelection != "undefined") {
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    });
                }
            }
        }

        return this;
    };
    editor.prototype.release = function () {
        this.$el.removeAttr('contenteditable');
        return this;
    };
    editor.prototype.isActive = function () {
        return !!this.$el.attr('contenteditable');
    };

    editor.prototype.html = function () {
        var html = this.$el.html();
        html = this.purifyChars(html);

        var re=/<br>/ig;
        html = html.replace(re, '<br />');

        _.each(validTags, function(tag) {
            var reUppercase=new RegExp("<(\/?)"+tag, "gi");
            html = html.replace(reUppercase, "<$1"+tag);
        });

        re=/(class|rel)=([\w-]+)/ig;
        html = html.replace(re, "$1='$2'");

        html = entify(html);

        html = html.replace(/[\s\n\r]*$/, '');
        html = html.replace(/^[\s\n\r]*/, '');

        return html;
    };
    editor.prototype.text = function () {
        return this.$el.text();
    };


    editor.prototype.commit = function () {
        var content;

        this.cleanup();
        $(this.el).find('.rangySelectionBoundary').remove();

        if (this.opts.mode==="text") {
           if (this.opts.newlines) {
                this.$el.find('*').not('br').each(function() {
                    removeNode(this);
                });
                content = this.html();
                content = content.replace(/^\s*<br \/>\s*$/, '');
            } else {
                content = this.$el.text();
            }
            content = this.purifyChars(content);
        } else {
            content = this.html();
        }

        var was = this.original,
            is = content;
        //this.$el.html(is);

        this.$el.trigger('change', {
            was: was,
            is: is
        });

        this.original = is;

        return this;
    };

    function getRange() {
        var sel;

        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                return sel.getRangeAt(0);
            }
        } else if (document.selection && document.selection.createRange) {
            return document.selection.createRange();
        }
    }

    editor.prototype.selectionSave = function () {
        $(this.el).find('.rangySelectionBoundary').remove();
        this.selection = window.rangy.saveSelection();

        return this.selection;
    };
    editor.prototype.selectionRestore = function () {
        var savedSel = this.selection;
        if (savedSel) {
            window.rangy.restoreSelection(savedSel);
        }
    };

    editor.prototype.queryCommand = function (sFormatString) {
        var opts = this.opts || {},
            cmds = opts.commands || {};


        var v;
        switch(sFormatString) {
            case 'link' :
                v  = opts.linking || cmds.link || 'yes';
                break;

            default:
                v  = cmds[sFormatString] || 'yes';
                break;
        }

        return (v !== 'no') && (v !== 'disabled');
    };

    editor.prototype.queryNode = function (tagname) {
        var sel = window.rangy.getSelection(),
            ancestor = sel.getRangeAt(0).commonAncestorContainer;

        if ($(ancestor).closest(tagname).length) {
            return $(ancestor).closest(tagname).get(0);
        } else {
            sel = window.rangy.getSelection();
            if (sel.rangeCount) {
                var links = sel.getRangeAt(0).getNodes([1], function(el) {
                    return el.nodeName.toLowerCase() == tagname;
                });
                if (links.length)
                    return links[0];
            }
        }
    };

    editor.prototype.applyCommand = function (sFormatString, opts) {
        var sel, range, ancestor, i, tool;
        opts = opts || {};

        switch (sFormatString.toLowerCase()) {

            case 'setlink':
                sel = window.rangy.getSelection();
                ancestor = sel.getRangeAt(0).commonAncestorContainer;
                if ($(ancestor).closest('a').length) {
                    ancestor = $(ancestor).closest('a').get(0);
                } else {
                    document.execCommand("CreateLink", false, opts.raw);

                    sel = window.rangy.getSelection();
                    if (sel.rangeCount) {
                        var links = sel.getRangeAt(0).getNodes([1], function(el) {
                            return el.nodeName.toLowerCase() == "a";
                        });
                        if (links.length)
                            ancestor = links[0];
                        else
                            ancestor = $(sel.getRangeAt(0).commonAncestorContainer).closest('a').get(0);
                    }
                }


                var $link = $(ancestor);
                if (opts.classname)
                    $link.addClass(opts.classname);

                $link.attr('descriptor', opts.descriptor);
                $link.removeAttr('title');
                $link.removeAttr('rel');
                $link.removeAttr('onclick');
                $link.removeAttr('target');

                if (opts.scripted) {
                    if ((opts.scriptmode)&&(opts.scriptmode==='href')) {
                        $link.attr('href', "javascript:"+opts.url);
                    } else {
                        $link.attr('href', opts.raw);
                        $link.attr('onclick', opts.url+";return false;");
                    }
                } else {
                    $link.attr('href', opts.url);

                    if ((opts.target)&&(opts.target!=='_top')&&(opts.target!=='_same'))
                        $link.attr('target', opts.target);

                    if (opts.onclick)
                        $link.attr('onclick', opts.url+"");
                }

                if (opts.relationship)
                    $link.attr('rel', opts.relationship);

                if (opts.title)
                    $link.attr('title', opts.title);

                _.each(opts.customAttributes, function(v, k) {
                    if (v)
                        $link.attr(k, v);
                    else
                        $link.removeAttr(k);
                });

                break;
            case 'settag':
                var tracer = '__settag',
                    ocls = opts.classname || '';
                ocls+= ' '+tracer;

                var isBlock = _.contains(blockLevelTags, opts.tag);
                if (isBlock) {
                    range = rangy.getSelection().getRangeAt(0);
                    var start = findClosestBlock(range.startContainer);
                    range.setStartBefore(start);

                    var end = findClosestBlock(range.endContainer);
                    range.setEndAfter(end);

                    var xElement = document.createElement(opts.tag);
                    range.surroundContents(xElement);
                    $(xElement).addClass(ocls);
                } else {
                    tool = window.rangy.createCssClassApplier(ocls, {
                        normalize: true,
                        elementTagName: opts.tag || 'span'
                    });
                    tool.toggleSelection();
                }

                var $nodes = this.$el.find('.'+tracer);
                $nodes.removeClass(tracer);
                return $nodes;



            case 'removeformat' :
                document.execCommand("removeFormat");
                document.execCommand("Unlink");

                var formattingEls = [], tops = [], $el;

                // http://stackoverflow.com/questions/13879813/remove-all-html-tags-inside-of-selection-in-contenteditable
                sel = window.rangy.getSelection();
                if (!sel.isCollapsed) {
                    for (i = 0; i < sel.rangeCount; ++i) {
                        range = sel.getRangeAt(i);
                        range.splitBoundaries();

                        // Get formatting elements. For this example, we'll count any
                        // element with display: inline, except <br>s.
                        formattingEls = formattingEls.concat(range.getNodes([1], function(el) {
                            return el.tagName != "BR" && getComputedDisplay(el) == "inline";
                        }));

                        tops = tops.concat(range.getNodes([1], function(el) {
                            return el.tagName == "BLOCKQUOTE" ;
                        }));

                        $el = $(range.commonAncestorContainer).closest('blockquote');
                        if ($el.length)
                            tops.push($el.get(0));
                    }
                }

                // Remove the formatting elements
                _.each(formattingEls, replaceWithOwnChildren);
                _.each(tops, replaceWithOwnChildren);

                break;
            case 'insertunorderedlist':
            case 'insertorderedlist':
                document.execCommand(sFormatString, false);
                if (opts.classname) {
                    range = getRange();
                    ancestor = $(range.commonAncestorContainer).closest('ul,ol');
                    ancestor.addClass(opts.classname);
                }
                break;
            default:
                document.execCommand(sFormatString, false);
                break;
        }


        return this;
    };


    editor.prototype.purifyChars = function (str) {
        if (this.opts.disablePurifyChars)
            return str;

        _.each(regs, function(reg) {
            str = str.replace(reg.subject, reg.replace);
        });

        return str;
   };

    editor.prototype.cleanup = function () {
        cleanupHTML(this.el, this.opts);
        return this;
    };



    var obj = {
        element: null,
        editing: null,
        cssOn: null,
        _din: false,

        rise: function($el, e) {
            if (obj.element===$el.get(0))
                return false;

            obj.fall();
            obj.element = $el.get(0);

            var opts = $el.data('editor') || {},
                cssOn = opts['css-active'] || 'editing',
                ed = new editor($el, opts);

            ed.activate(e).$el.addClass(cssOn);
            obj.editing = ed;
            obj.cssOn = cssOn;

            $el.on('mousedown.Texteditor', function dinon() {
                obj._din = true;
            });
            $el.on('mouseup.Texteditor', function dinoff() {
                obj._din = false;
            });
            $('body').on('mousedown.Texteditor quake.Texteditor', obj.fall);

            return true;
        },
        fall: function() {
            if (!obj.editing) return;

            obj.editing.commit().destroy().$el.removeClass(obj.cssOn);
            $(obj.element).off('.Texteditor');
            $('body').off('.Texteditor');

            obj.editing = null;
            obj.element = null;
            obj.cssOn = null;
            obj._din = false;
        },
        cleanup: cleanupHTML
    };


    return obj;
})(jQuery, _);